import {useCallback, useEffect, useState} from 'react';
import type {AiChatPreferences} from '@Components/ai-chat-window/lib/ai-chat-preferences.library';
import { hideActionTiles} from '@Components/ai-chat-window/lib/ai-chat-preferences.library';
import {DEFAULT_PREFERENCES, getAiChatPreferences, hasUserSeenAiChatTemplatesTile, markAiChatTemplatesTileAsSeen} from '@Components/ai-chat-window/lib/ai-chat-preferences.library';

interface UseAiChatTilePreferencesReturn {
  preferences: AiChatPreferences | null;
  hasSeenTemplatesTile: boolean;
  hideActionTilesPermanently: () => void;
  markTemplatesTileAsSeen: () => void;
}

export function useAiChatTilePreferences(isLoggedIn: boolean): UseAiChatTilePreferencesReturn {
  const [preferences, setPreferences] = useState<AiChatPreferences | null>(isLoggedIn ? null : DEFAULT_PREFERENCES);
  const [hasSeenTemplatesTile, setHasSeenTemplatesTile] = useState<boolean>(false);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    void getAiChatPreferences().then(setPreferences);
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }
    void hasUserSeenAiChatTemplatesTile().then(setHasSeenTemplatesTile);
  }, [isLoggedIn]);

  const hideActionTilesPermanently = useCallback((): void => {
    setPreferences((prev) => (prev ? {...prev, areActionTilesHidden: true} : {areActionTilesHidden: true}));
    void hideActionTiles();
  }, []);

  const markTemplatesTileAsSeen = useCallback((): void => {
    setHasSeenTemplatesTile((prev) => {
      if (prev) {
        return prev;
      }
      void markAiChatTemplatesTileAsSeen().catch((e: unknown) => {
        console.error('Failed to mark templates tile as seen:', e);
      });
      return true;
    });
  }, []);

  return {
    preferences,
    hasSeenTemplatesTile,
    hideActionTilesPermanently,
    markTemplatesTileAsSeen,
  };
}
